var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcRoundPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "#5D5CF5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 10.8307H10.8337V14.9974C10.8337 15.2184 10.7459 15.4304 10.5896 15.5867C10.4333 15.7429 10.2213 15.8307 10.0003 15.8307C9.77931 15.8307 9.56735 15.7429 9.41107 15.5867C9.25479 15.4304 9.16699 15.2184 9.16699 14.9974V10.8307H5.00033C4.77931 10.8307 4.56735 10.7429 4.41107 10.5867C4.25479 10.4304 4.16699 10.2184 4.16699 9.9974C4.16699 9.77638 4.25479 9.56442 4.41107 9.40814C4.56735 9.25186 4.77931 9.16406 5.00033 9.16406H9.16699V4.9974C9.16699 4.77638 9.25479 4.56442 9.41107 4.40814C9.56735 4.25186 9.77931 4.16406 10.0003 4.16406C10.2213 4.16406 10.4333 4.25186 10.5896 4.40814C10.7459 4.56442 10.8337 4.77638 10.8337 4.9974V9.16406H15.0003C15.2213 9.16406 15.4333 9.25186 15.5896 9.40814C15.7459 9.56442 15.8337 9.77638 15.8337 9.9974C15.8337 10.2184 15.7459 10.4304 15.5896 10.5867C15.4333 10.7429 15.2213 10.8307 15.0003 10.8307Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcRoundPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_round-plus.bec98321.svg";
export { ForwardRef as ReactComponent };